let translations;
export default (path, values) => {
    if (!translations) {
        translations = JSON.parse(document.querySelector('body').dataset.translations);
    }
    let trad = translations[path] || path;
    if (values) {
        Object.entries(values).forEach(([key, value]) => {
            trad = trad.replace(`{${key}}`, value);
        });
    }
    return trad;
};
